import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { ProductsSkuListFiltersArray } from './Filters'

const ProductsSkuListFilters: React.FC<Omit<FilterProps, 'children'>> = (
  props
) => {
  return (
    <Filter {...props}>
      {ProductsSkuListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default ProductsSkuListFilters
